import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Natraj pencils -x90",
    desc: "this is a dummy text, to explain more about the product description",
    price: "500",
    coverImg: { link: "https://i2-prod.manchestereveningnews.co.uk/incoming/article11851328.ece/ALTERNATES/s1200c/CS49004805.jpg", alt: "Natraj pencils -x90" },
    category: ["student"],
    ratings: "3",
  },
  {
    _id: uuid(),
    title: "Shinota erasers -x53",
    desc: "this is a dummy text, to explain more about the product description",
    price: "350",
    coverImg: { link: "https://qph.fs.quoracdn.net/main-qimg-ecd9c3645f18c9925700fbad951b4116-lq", alt: "Shinota erasers -x53" },
    category: ["student"],
    ratings: "4.5",
  },
  {
    _id: uuid(),
    title: "Montseraat Pens -x66",
    desc: "this is a dummy text, to explain more about the product description",
    price: "600",
    coverImg: { link: "https://m.media-amazon.com/images/I/616tqxn3bwL._SY450_.jpg", alt: "Montseraat Pens -x66" },
    category: ["student"],
    ratings: "4.7",
  },
  {
    _id: uuid(),
    title: "Calyxpod Pens -x58",
    desc: "this is a dummy text, to explain more about the product description",
    price: "580",
    coverImg: { link: "https://m.media-amazon.com/images/I/41L1PCld4SL.jpg", alt: "Calyxpod Pens -x58" },
    category: ["student"],
    ratings: "3.8",

  },
  {
    _id: uuid(),
    title: "Bundly Stappler -x57",
    desc: "this is a dummy text, to explain more about the product description",
    price: "735",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGIUDORkEDVkCWjtoaT4J7_7wYEkV4rygrXg&usqp=CAU", alt: "Bundly Stappler -x57" },
    category: ["student", "office"],
    ratings: "4",
  },
  {
    _id: uuid(),
    title: "Stamped Envelopes -x64",
    desc: "this is a dummy text, to explain more about the product description",
    price: "555",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSudvK1Dh3CgD9Du8R_NAqVShwa6EooexK0xw&usqp=CAU", alt: "Stamped Envelopes -x64" },
    category: ["office"],
    ratings: "4.9",
  },
  {
    _id: uuid(),
    title: "Shinota Strops -x64",
    desc: "this is a dummy text, to explain more about the product description",
    price: "465",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGKtyhi7VVHtPVLYMqBBg_Er9NqvCmYo_n-Q&usqp=CAU", alt: "Shinota Strops -x64" },
    category: ["student"],
    ratings: "4.5",
  },
  {
    _id: uuid(),
    title: "Kortana Case -x77",
    desc: "this is a dummy text, to explain more about the product description",
    price: "800",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDcmrWz-5SS8HPgSSjtPo1LcqljLoxoThG8w&usqp=CAU", alt: "Kortana Case -x77" },
    category: ["student"],
    ratings: "2.5",
  },
  {
    _id: uuid(),
    title: "Soshoma Clips -x76",
    desc: "this is a dummy text, to explain more about the product description",
    price: "125",
    coverImg: { link: "https://cdn.images.fecom-media.com/FE00003787/images/265wb.jpg?width=578&height=578&scale=UpscaleCanvas&anchor=MiddleCenter", alt: "Soshoma Clips -x76" },
    category: ["office"],
    ratings: "3",
  },
  {
    _id: uuid(),
    title: "Binder Clips -x87",
    desc: "this is a dummy text, to explain more about the product description",
    price: "175",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRri45cP-Z7mHtWmOVBX5vNkb-IalG5HAeLuw&usqp=CAU", alt: "Binder Clips -x87" },
    category: ["office"],
    ratings: "2.9",
  },
  {
    _id: uuid(),
    title: "Nota organiser -x71",
    desc: "this is a dummy text, to explain more about the product description",
    price: "999",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUvB6RURRGcQDDArZPRHK9A2unLGD2tbd1fA&usqp=CAU", alt: "Nota organiser -x71" },
    category: ["student"],
    ratings: "4",
  },
  {
    _id: uuid(),
    title: "Strontium Notebooks -x98",
    desc: "this is a dummy text, to explain more about the product description",
    price: "860",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKF7OKgXmumlM-LnFj5974RhKzY8bbW9Ip4w&usqp=CAU", alt: "Strontium Notebooks -x98" },
    category: ["student"],
    ratings: "3.4",
  },
  {
    _id: uuid(),
    title: "Strontium Spirals -x38",
    desc: "this is a dummy text, to explain more about the product description",
    price: "625",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSm7QY1mrbwsGaIZu18ROmkYbqg9c4t6_yxKQ&usqp=CAU", alt: "Strontium Spirals -x38" },
    category: ["office"],
    ratings: "3.2",
  },
  {
    _id: uuid(),
    title: "Shwet Whiteners -x22",
    desc: "this is a dummy text, to explain more about the product description",
    price: "99",
    coverImg: { link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgkvZAp00zN3mJ9nIe7o3pEs10L5cOdoOFbA&usqp=CAU", alt: "Shwet Whiteners -x22" },
    category: ["student", "office"],
    ratings: "1.2",
  },
];

